import { render } from "./DocumentContainer.vue?vue&type=template&id=73347e00&scoped=true"
import script from "./DocumentContainer.vue?vue&type=script&lang=js"
export * from "./DocumentContainer.vue?vue&type=script&lang=js"

import "./DocumentContainer.vue?vue&type=style&index=0&id=73347e00&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73347e00"]])

export default __exports__